import React from "react";
import metabo from "../../images/metabo.png";
import makita from "../../images/makita.jpg";
import sandvik from "../../images/sandvik.jpg";
import milwaukee from "../../images/Milwaukee.jpg";
import distar from "../../images/distar.jpg";
import germaflex from "../../images/germaflex.jpg";
import insize from "../../images/insize.jpg";

const ToolsSellBody = () => {
    return (
        <>
            <div className="m-auto max-w-6xl p-2 md:p-12 h-5/6" id="intro2">
                <div className="my-4 py-4">
                    <h1 className="my-2 text-center text-3xl text-brand uppercase font-bold">Predaj náradia</h1>

                    <div className='flex justify-center'>
                        <div className='w-24 border-b-4 border-brand'></div>
                    </div>
                    <h2 className="mt-4 mx-12 text-center text-xl lg:text-2xl font-semibold text-black">Ponúkame predaj
                        elektrického naradia renomovaných značiek</h2>
                </div>
                <div className="p-2">
                    <p className="mb-4 text-xl">
                        Pri výbere elektrického náradia je kľúčové zamerať sa na kvalitu a renomované značky, ktoré
                        zaručujú dlhú životnosť a spoľahlivosť. Zákazníci, ktorí uprednostňujú kvalitu, si môžu byť
                        istí, že ich investícia do vysokej triedy elektrického náradia sa rýchlo vráti v podobe
                        dlhodobej spokojnosti a minimálnej potreby údržby. Známe značky ako Metabo, Makita,
                        či
                        Milwaukee ponúkajú širokú škálu produktov, ktoré sú navrhnuté tak, aby vyhovovali potrebám
                        profesionálov aj domácich majstrov. Ich produkty sú synonymom inovácie a výkonu, čo z nich robí
                        ideálnu voľbu pre každého, kto hľadá spoľahlivé a výkonné elektrické náradie pre akúkoľvek
                        prácu.
                    </p>
                    <p className="mb-4 text-xl">
                        Pri nákupe u nás môžete očakávať nielen špičkovú kvalitu, ale aj vynikajúce zákaznícke služby.
                        Spolupracujeme s renomovanými značkami a výrobcami elektrického náradia, čo zaručuje
                        spoľahlivosť a dlhú životnosť našich produktov.
                    </p>

                    <p className="text-xl">
                        Okrem toho poskytujeme rôzne záruky, garancie a servisné služby, aby ste mali pokojné srdce pri
                        každom nákupe u nás.
                    </p>
                </div>
                <div
                    className="flex flex-col items-center text-left  lg:flex-row py-8 justify-between"
                    data-aos="fade-up"
                >
                    <div className="lg:w-1/2 flex flex-col lg:mx-8 justify-center">
                        <img src={metabo} className="w-max" alt={'Predaj náradia - METABO'}/>
                    </div>
                    <div
                        className="flex-col my-4 text-left lg:my-0 lg:justify-end lg:w-1/2 px-8"
                        data-aos="zoom-in"
                        data-aos-delay="500"
                    >

                        <div>
                            <ul className="list-disc marker:text-green text-xl">
                                <li className='text-brand'>
                                    <span className="text-black">Akumulátorové systémy</span>
                                </li>
                                <li className='text-brand'>
                                    <span className="text-black">Akumulátorové náradie</span>
                                </li>
                                <li className='text-brand'>
                                    <span className="text-black">Rezanie, Brúsenie, Frézovanie</span>
                                </li>
                                <li className='text-brand'>
                                    <span className="text-black">Vŕtanie, Skrutkovanie, Sekanie, Miešanie</span>
                                </li>
                                <li className='text-brand'>
                                    <span className="text-black">Odpojenie, brúsenie, obrábanie kovov</span>
                                </li>
                                <li className='text-brand'>
                                    <span className="text-black">Obrábanie dreva</span>
                                </li>
                                <li className='text-brand'>
                                    <span className="text-black">Uhlové brúsky</span>
                                </li>
                                <li className='text-brand'>
                                    <span className="text-black">Opracovávanie kovov</span>
                                </li>
                                <li className='text-brand'>
                                    <span className="text-black">Nerez</span>
                                </li>
                                <li className='text-brand'>
                                    <span className="text-black">Vŕtacie a sekacie kladivá</span>
                                </li>
                                <li className='text-brand'>
                                    <span className="text-black">Ručné okružné píly</span>
                                </li>
                                <li className='text-brand'>
                                    <span className="text-black">Priamočiare píly</span>
                                </li>
                                <li className='text-brand'>
                                    <span className="text-black">Skracovacie píly</span>
                                </li>
                                <li className='text-brand'>
                                    <span className="text-black">Multitool</span>
                                </li>
                            </ul>
                        </div>
                    </div>
                </div>
                <div
                    className="flex flex-col items-center text-left  lg:flex-row py-8 justify-between"
                    data-aos="fade-up"
                >
                    <div className="lg:w-1/2 flex flex-col lg:mx-8 justify-center">
                        <img src={makita} className="w-max" alt={"MAKITA"}/>
                    </div>
                    <div
                        className="flex-col my-4 text-left lg:my-0 lg:justify-end lg:w-1/2 px-8"
                        data-aos="zoom-in"
                        data-aos-delay="500"
                    >

                        <div>
                            <ul className="list-disc marker:text-green text-xl">
                                <li className='text-brand'>
                                    <span className="text-black">Akumulátorové systémy</span>
                                </li>
                                <li className='text-brand'>
                                    <span className="text-black">Akumulátorové náradie</span>
                                </li>
                                <li className='text-brand'>
                                    <span className="text-black">Rezanie, Brúsenie, Frézovanie</span>
                                </li>
                                <li className='text-brand'>
                                    <span className="text-black">Vŕtanie, Skrutkovanie, Sekanie, Miešanie</span>
                                </li>
                                <li className='text-brand'>
                                    <span className="text-black">Prestirhovače</span>
                                </li>
                                <li className='text-brand'>
                                    <span className="text-black">Nožnice na plech</span>
                                </li>
                                <li className='text-brand'>
                                    <span className="text-black">Pásové píly</span>
                                </li>
                                <li className='text-brand'>
                                    <span className="text-black">Uhlová brúska</span>
                                </li>

                                <li className='text-brand'>
                                    <span className="text-black">Píly na kov</span>
                                </li>
                                <li className='text-brand'>
                                    <span className="text-black">Diamantové rezačky</span>
                                </li>
                                <li className='text-brand'>
                                    <span className="text-black">Uhlové rezačky</span>
                                </li>
                                <li className='text-brand'>
                                    <span className="text-black">Drážkovacie frézy do muriva</span>
                                </li>
                            </ul>
                        </div>
                    </div>
                </div>
                <div
                    className="flex flex-col items-center text-left  lg:flex-row py-8 justify-between"
                    data-aos="fade-up"
                >
                    <div className="lg:w-1/2 flex flex-col lg:mx-8 justify-center">
                        <img src={sandvik} className="w-max" alt="Predaj náradia - SANDVIK"/>
                    </div>
                    <div
                        className="flex-col my-4 text-left lg:my-0 lg:justify-end lg:w-1/2 px-8"
                        data-aos="zoom-in"
                        data-aos-delay="500"
                    >

                        <div>
                            <ul className="list-disc marker:text-green text-xl">
                                <li className='text-brand'>
                                    <span className="text-black">Nástroje na sústruženie</span>
                                </li>
                                <li className='text-brand'>
                                    <span className="text-black">Nástroje na výrobu závitov</span>
                                </li>
                                <li className='text-brand'>
                                    <span className="text-black">Nástroje na frézovnie</span>
                                </li>
                                <li className='text-brand'>
                                    <span className="text-black">Nástroje na vŕtanie</span>
                                </li>
                                <li className='text-brand'>
                                    <span className="text-black">TK plátky</span>
                                </li>
                                <li className='text-brand'>
                                    <span className="text-black">Systémy na upínanie nástrojov</span>
                                </li>
                            </ul>
                        </div>
                    </div>
                </div>

                <div
                    className="flex flex-col items-center text-left  lg:flex-row py-8 justify-between"
                    data-aos="fade-up"
                >
                    <div className="lg:w-1/2 flex flex-col lg:mx-8 justify-center">
                        <img src={insize} className="w-max" alt="Predaj náradia - INSIZE"/>
                    </div>
                    <div
                        className="flex-col my-4 text-left lg:my-0 lg:justify-end lg:w-1/2 px-8"
                        data-aos="zoom-in"
                        data-aos-delay="500"
                    >

                        <div>
                            <ul className="list-disc marker:text-green text-xl">
                                <li className='text-brand'>
                                    <span className="text-black">Posuvné meradlá</span>
                                </li>
                                <li className='text-brand'>
                                    <span className="text-black">Hĺbkomery</span>
                                </li>
                                <li className='text-brand'>
                                    <span className="text-black">Kalibre</span>
                                </li>
                                <li className='text-brand'>
                                    <span className="text-black">Odchýlkomery</span>
                                </li>
                                <li className='text-brand'>
                                    <span className="text-black">Mikrometre</span>
                                </li>
                                <li className='text-brand'>
                                    <span className="text-black">Váhy a závažia</span>
                                </li>
                                <li className='text-brand'>
                                    <span className="text-black">Hrúbkomery</span>
                                </li>
                            </ul>
                        </div>
                    </div>
                </div>

                <div
                    className="flex flex-col items-center text-left  lg:flex-row py-8 justify-between"
                    data-aos="fade-up"
                >
                    <div className="lg:w-1/2 flex flex-col lg:mx-8 justify-center">
                        <img src={distar} className="w-max" alt="DISTAR"/>
                    </div>
                    <div
                        className="flex-col my-4 text-left lg:my-0 lg:justify-end lg:w-1/2 px-8"
                        data-aos="zoom-in"
                        data-aos-delay="500"
                    >

                        <div>
                            <ul className="list-disc marker:text-green text-xl">
                                <li className='text-brand'>
                                    <span className="text-black">Diamantové kotúče</span>
                                </li>
                                <li className='text-brand'>
                                    <span className="text-black">Diamantové brúsne taniere</span>
                                </li>
                                <li className='text-brand'>
                                    <span className="text-black">Diamantové jadrové vrtáky</span>
                                </li>
                            </ul>
                        </div>
                    </div>
                </div>

                <div
                    className="flex flex-col items-center text-left  lg:flex-row py-8 justify-between"
                    data-aos="fade-up"
                >
                    <div className="lg:w-1/2 flex flex-col lg:mx-8 justify-center">
                        <img src={germaflex} className="w-max" alt="Predaj náradia - Germaflex"/>
                    </div>
                    <div
                        className="flex-col my-4 text-left lg:my-0 lg:justify-end lg:w-1/2 px-8"
                        data-aos="zoom-in"
                        data-aos-delay="500"
                    >

                        <div>
                            <ul className="list-disc marker:text-green text-xl">
                                <li className='text-brand'>
                                    <span className="text-black">Rezné a brúsne kotúče</span>
                                </li>
                                <li className='text-brand'>
                                    <span className="text-black">Lamelové kotúče</span>
                                </li>
                                <li className='text-brand'>
                                    <span className="text-black">Brúsne pásy</span>
                                </li>
                                <li className='text-brand'>
                                    <span className="text-black">Brúsne disky</span>
                                </li>
                            </ul>
                        </div>
                    </div>
                </div>


                <div
                    className="flex flex-col items-center text-left  lg:flex-row py-8 justify-between"
                    data-aos="fade-up"
                >
                    <div className="lg:w-1/2 flex flex-col lg:mx-8 justify-center">
                        <img src={milwaukee} className="w-max" alt="Predaj náradia - Milwaukee"/>
                    </div>
                    <div
                        className="flex-col my-4 text-left lg:my-0 lg:justify-end lg:w-1/2 px-8"
                        data-aos="zoom-in"
                        data-aos-delay="500"
                    >

                        <div>
                            <ul className="list-disc marker:text-green text-xl">
                                <li className='text-brand'>
                                    <span className="text-black">Akumulátory, nabíjačky a napájacie zdroje</span>
                                </li>
                                <li className='text-brand'>
                                    <span className="text-black">Elektrické náradie</span>
                                </li>
                                <li className='text-brand'>
                                    <span className="text-black">Stroje na vonkajšie použite</span>
                                </li>
                                <li className='text-brand'>
                                    <span className="text-black">Osvetlenie</span>
                                </li>
                                <li className='text-brand'>
                                    <span className="text-black">Ručné náradie</span>
                                </li>
                            </ul>
                        </div>
                    </div>
                </div>

                <h3 className="mt-4 mx-12 text-center text-xl lg:text-2xl font-semibold text-black">
                    V prípade akýchkoľvek otázok ohľadom objednávky a cenovej ponuky na daný produkt, či službu
                    nás kontaktujte.
                </h3>

            </div>
        </>
    );
};

export default ToolsSellBody;
